import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { useHistory } from "react-router-dom";
import classes from "../../templateBuilder/templateBuilder.module.css";
import Table from "../../templateBuilder/Table/Table";
import Collapsable from "../../collapsable";
import { Tabs } from "antd";
import responseLoader from "../../Responses/responseLoader";
import axios from "../../../../Axios";
import { useSelector } from "react-redux";
import Layover from "../../responseSelect";
import loadSwitch from "../../Responses/mandatoryLoader";
const { TabPane } = Tabs;

const TemplateBuilder = () => {
  const responseList = useSelector((state) => state.responses);
  const history = useHistory();
  const [panes, setPanes] = useState([]);
  const [activeKey, setActiveKey] = useState(null);
  const [templateTitle, setTemplateTitle] = useState(null);
  const [layoverShown, setLayoverShown] = useState([false, -1, -1]);
  let responses = null;

  const tempResponses = responseLoader(responseList);
  responses = tempResponses;

  useEffect(() => {
    const urlParams = new URLSearchParams(history.location.search);
    const id = urlParams.get("id");
    if (id) {
      const fetchTemplate = async () => {
        const template = await axios.post("/templates/fetch", {
          fetchType: 0,
          fetchItems: [],
          where: { _id: id },
        });

        const { payload } = template.data;
        console.log(payload);
        setTemplateTitle(payload[0].title);
        const panes = payload[0].panes.map((pane) => {
          const tempContent = pane.content.map((content) => {
            return {
              ...content,
              ["mandatory"]: (
                <ul className={classes.mandatoryChecks}>
                  {content.mandatory.map((mandatory) => (
                    <li>
                      <i class="far fa-check-circle"></i>
                      <span>{loadSwitch().mandatoryResponse(mandatory)}</span>
                    </li>
                  ))}
                </ul>
              ),
            };
          });
          return { ...pane, ["content"]: tempContent };
        });
        setPanes(panes);
        setActiveKey(payload[0].panes[0] ? payload[0].panes[0]._id : null);
      };
      fetchTemplate();
    }
  }, []);
  const layoverSwitch = (indOne, indTwo) => {
    if (!layoverShown[0]) {
      setLayoverShown([true, indOne, indTwo]);
      return 0;
    }

    setLayoverShown([false, -1, -1]);
  };
  const onPaneChange = (newActiveKey) => {
    let targetIndex = null;
    if (newActiveKey !== activeKey) {
      panes.forEach((pane, index) => {
        if (pane.key === activeKey) targetIndex = index;
      });
      if (targetIndex !== null) {
        const input = document.getElementsByClassName(classes.colr)[
          targetIndex
        ];
        input.setAttribute("disabled", "true");
      }
    }
    setActiveKey(newActiveKey);
  };

  const mandatoryHandle = (check, data) => {
    const tempPanes = [...panes];
    const tempPane = { ...tempPanes[layoverShown[1]] };

    const tempContent = [...tempPane.content];
    const tempQuestion = { ...tempContent[layoverShown[2]] };

    const tempMandatory = new Set(tempQuestion.mandatory);

    if (check) tempMandatory.add(data);
    else tempMandatory.delete(data);

    tempQuestion.mandatory = [...Array.from(tempMandatory)];
    tempContent[layoverShown[2]] = tempQuestion;

    tempPane.content = tempContent;
    tempPanes[layoverShown[1]] = tempPane;
    setPanes(tempPanes);
  };

  const headings = {
    "s no.": "s no.",
    "audit question": "question",
    response: "answer",
    mandatory: "mandatory",
  };
  return (
    <div>
      <div className={classes.builderHead}>
        <h2>
          <span>
            <input
              placeholder="Template Name"
              value={templateTitle}
              disabled
              className={[classes.colrHead].join(" ")}
            />
          </span>
        </h2>
      </div>
      <hr />
      <Tabs activeKey={activeKey} type="card" onChange={onPaneChange}>
        {panes.map((pane, index) => {
          console.log(pane._id);
          return (
            <TabPane
              tab={
                <div>
                  <input
                    className={classes.colr}
                    placeholder="New Section"
                    disabled
                    type="text"
                    value={pane.title}
                  />
                </div>
              }
              key={pane._id}
              closable={pane.closable}
              className={classes.tab}
            >
              <div className={classes.paneContent}>
                {
                  <Collapsable
                    heading={pane.title ? pane.title : "New Section"}
                    extraClass={classes.collapsable}
                    collapseClass={classes.collapse}
                    inputs={
                      <>
                        <Table
                          datas={pane.content}
                          layoverShown={layoverShown}
                          layoverSwitch={(ind) => layoverSwitch(index, ind)}
                          headings={headings}
                          responses={responses}
                        ></Table>
                      </>
                    }
                  />
                }
              </div>
            </TabPane>
          );
        })}
      </Tabs>
      <Layover
        selected={
          layoverShown[0] && panes[layoverShown[1]].content[layoverShown[2]]
            ? panes[layoverShown[1]].content[layoverShown[2]].answer
            : null
        }
        checked={
          layoverShown[0] && panes[layoverShown[1]].content[layoverShown[2]]
            ? panes[layoverShown[1]].content[layoverShown[2]].mandatory
            : []
        }
        visible={layoverShown[0]}
        mandatoryHandle={mandatoryHandle}
      ></Layover>
    </div>
  );
};

export default TemplateBuilder;
